import React, { useState, useEffect } from 'react';
import {
  Container, Grid, Typography, Button, Select, MenuItem,
  FormControl, InputLabel, Box, Snackbar, Alert, CircularProgress
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CorrectionModal from './CorrectionModal';
import parsingImage from '../img/cv-parsing.png';
import '../css/AjouterCv.css';
import { parseProxyUrl } from '../api';

const AjouterCv = () => {
  const [template, setTemplate] = useState('option1');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState('Utilisateur');
  const [extractedData, setExtractedData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  useEffect(() => {
    const name = localStorage.getItem('userName') || 'Utilisateur';
    setUserName(name);
  }, []);

  const showMessage = (message, severity = 'info') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      showMessage("Merci de sélectionner un fichier.", "warning");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('choice', template);

    try {
      const response = await fetch(parseProxyUrl('/corrections/'), {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        let apiMessage = "Erreur lors de l'appel à l'API externe.";
        try {
          const errJson = await response.json();
          if (errJson?.error) apiMessage = errJson.error;
        } catch (_) {
          // Ignore JSON parse errors and keep default message.
        }
        throw new Error(apiMessage);
      }

      const jsonResult = await response.json();
      if (jsonResult.status === 'success') {
        setExtractedData(jsonResult.data);
        setModalOpen(true);
      } else {
        showMessage("Aucune donnée extraite.", 'error');
      }
    } catch (err) {
      console.error("Erreur :", err);
      showMessage(err.message || "Une erreur est survenue. Vérifiez le serveur distant.", 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Bonjour {userName}, déposez un CV à parser
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <img src={parsingImage} alt="Illustration Parsing" style={{ width: '100%', borderRadius: 8 }} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="template-label">Modèle de CV</InputLabel>
              <Select
                labelId="template-label"
                id="template"
                value={template}
                label="Modèle de CV"
                onChange={(e) => setTemplate(e.target.value)}
              >
                <MenuItem value="option1">Consult</MenuItem>
                <MenuItem value="option2">Atos</MenuItem>
                <MenuItem value="option3">Sopra</MenuItem>
              </Select>
            </FormControl>

            <Button variant="outlined" component="label" startIcon={<CloudUploadIcon />}>
              {file ? file.name : "Sélectionner un fichier"}
              <input hidden type="file" accept=".pdf,.docx" onChange={handleFileChange} />
            </Button>

            <Button type="submit" variant="contained" color="primary" disabled={loading}>
              {loading ? (
                <CircularProgress size={24} sx={{ color: "#fff" }} />
              ) : "Analyser le CV"}
            </Button>
          </Box>
        </Grid>
      </Grid>

      {/* ✅ Modal de correction */}
      <CorrectionModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        data={extractedData}
        model={template}
      />

      {/* ✅ Snackbar messages */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} onClose={handleCloseSnackbar}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default AjouterCv;
